export enum ResponseMessages {
  OPERATION_SUCCES = "OPERATION_SUCCES",
}
